<template>
  <div class="user-preview">
    <!-- USERで表示される画面のプレビュー表示 -->
    <div id="contents">
      <div class="inner clearfix detail-top">
        <p
          v-if="photoClip.companyName"
          class="mt10 fll hd-type-01 company-name"
          data-test="company-name"
        >
          {{ photoClip.companyName }}
        </p>
        <div class="clear" />
        <ul class="mt30 fs13 detail-menu">
          <a>
            <li data-test="tab-menu-job">募集情報</li>
          </a>
          <span>
            <li
              data-test="tab-menu-photo-clip"
              class="active"
            >フォトクリップ</li>
          </span>
          <a>
            <li data-test="tab-menu-interview">インタビュー記事</li>
          </a>
        </ul>
        <div
          v-if="photoClip.companyName"
          class="company-area"
        >
          <h1
            class="fs16 hd-type-02 company-title option-title"
            data-test="photo-clip-title"
          >
            {{ photoClip.companyName }}のフォトクリップ
          </h1>
        </div>
        <div
          id="photoclips"
          class="contents-inner clearfix mb30"
        >
          <section>
            <article class="flex-container">
              <template v-for="(photoInfo, i) in photoClip.photoInfoList">
                <figure
                  :key="i"
                  :data-test="`photo-clip-${i}`"
                  class="photoclip"
                  :style="`background: url(${userImageUrlForPc}/top/bg_01.png) repeat left;`"
                >
                  <img
                    v-if="photoInfo.image"
                    :src="getPhotoUrl(photoInfo.image)"
                    :data-test="`photo-${i}`"
                  >
                  <figcaption
                    v-if="photoInfo.caption"
                    class="p15 pega-pre-wrap"
                    :data-test="`caption-${i}`"
                    v-text="photoInfo.caption"
                  />
                </figure>
              </template>
            </article>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/photoclip/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    photoClip: {
      type: Object,
      required: true
    }
  }
}
</script>
